import './ProfilePage.scss';
import { useMemo, useState } from 'react';
import { useLang } from '../../i18n';
import Tabs from '../../components/Tabs';
import ProfileMain from './components/ProfileMain';
import ProfileSecurity from './components/ProfileSecurity';
import ProfileNotifications from './components/ProfileNotifications';
import ProfileChannels from './components/ProfileChannels';
import ProfileApi from './components/ProfileApi';

type TabKey = 'profile' | 'security' | 'notifications' | 'channels' | 'api';

export default function ProfilePage() {
  const { t } = useLang();
  const [tab, setTab] = useState<TabKey>('profile');

  const tabs = useMemo(() => ([
    { value: 'profile', label: t('profile.tab.profile') },
    { value: 'security', label: t('profile.tab.security') },
    { value: 'notifications', label: t('profile.tab.notifications') },
    { value: 'channels', label: t('profile.tab.channels') },
    { value: 'api', label: t('profile.tab.api') },
  ]), [t]);

  return (
    <div className="profile">
      <h1 className="profile__title">{t('profile.title')}</h1>
      <Tabs value={tab} onChange={(v) => setTab(v as TabKey)} items={tabs} ariaLabel={t('profile.title')} />
      <div className="profile__panel">
        {tab === 'profile' && <ProfileMain />}
        {tab === 'security' && <ProfileSecurity />}
        {tab === 'notifications' && <ProfileNotifications />}
        {tab === 'channels' && <ProfileChannels />}
        {tab === 'api' && <ProfileApi />}
      </div>
    </div>
  );
}
